import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CatalogTreeCardObject } from 'src/app/models/catalog/catalog-tree-item-object.model';
import { TreeItemObject } from 'src/app/models/catalog/tree-item-object.model';
import { StringUtils } from 'src/app/services/utils/string.utils';

@Component({
  selector: 'app-catalog-card-node',
  templateUrl: './catalog-card-node.component.html',
  styleUrls: ['./catalog-card-node.component.scss']
})
export class CatalogCardNodeComponent implements OnInit{

    @Input() node: TreeItemObject;
    @Input() selectedNode: TreeItemObject;
    @Output() clickCard = new EventEmitter<TreeItemObject>();
    title: string;

    constructor() {
    }

    ngOnInit() {
      this.title = this.getTitle();
    }

    click() {
        this.clickCard.emit(this.node);
    }

    isClicked(): boolean {
        return this.node.id === this.selectedNode.id;
    }

    public getMessage() {
      let message = StringUtils.NOT_AVALIABLE;
      message += "Depende de: ";

      this.node.dependencies.forEach(dependency => {
          if (message.length > 0) {
              message += ' ';
          }
          message += dependency.name;
      });

      return message;
  }

  public getTitle(): string {
    let title = this.node.type;
    switch(title) {
        case 'CFS': {
            title = 'SERVICE DEFINITION (CFS)';
            break;
        }
        case 'RFS': {
            title = 'SERVICE DEFINITION (RFS)';
            break;
        }
        default: {
            title = 'PRODUCT SPECIFICATION';
        }
    }
    return title;
  }

}
